/**
 * ServiceOrderShipmentsTab - Aba "Remessas" do modal da O.S. (Logística, Fase 4).
 * Invólucro fino sobre o `EntityShipmentsTab` (mesmo componente da aba do Negócio).
 *
 * RELEASE: 2026-10-16 v1.2.0 - "Nova remessa" só com a O.S. Aberta (regra de set_shipment_link v1.3.0).
 * RELEASE: 2026-10-16 v1.1.0 - Passa a reaproveitar EntityShipmentsTab (sem mudança de comportamento).
 * RELEASE: 2026-10-16 v1.0.0 - Versão inicial.
 */
import { EntityShipmentsTab } from '@/components/logistics/EntityShipmentsTab';
import { canLinkShipmentToServiceOrder } from '@/hooks/useServiceOrders';

interface Props {
  serviceOrderId: string;
  /** Número da O.S. exibido no vínculo automático da nova remessa. */
  serviceOrderNumber?: string | null;
  customer: { id: string; name: string } | null;
  /** Situação atual da O.S. (remessa só com Aberta). */
  status?: string | null;
}

export function ServiceOrderShipmentsTab({ serviceOrderId, serviceOrderNumber, customer, status }: Props) {
  return (
    <EntityShipmentsTab entityType="service_order" entityId={serviceOrderId} entityLabel={serviceOrderNumber}
      customer={customer} emptyText="Nenhuma remessa vinculada a esta O.S."
      createBlockedReason={canLinkShipmentToServiceOrder(status) ? null : 'Só é possível criar remessa com a O.S. Aberta'} />
  );
}
